import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queueApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/** Leave a recovered court-line entry through the canonical queue delete route. */
export function useLeaveLine(facilityId: string) {
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>({
    mutationFn: (entryId: string) => queueApi.leave(entryId),
    onSettled: (_data, _error, entryId) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.queueEntry(entryId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: ["dropin", "my-entry", facilityId],
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.courtBoard(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.myParty(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.partyMemberships(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.queueStats(facilityId),
        refetchType: "active",
      });
    },
  });
}
